// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2zO9h","gfeWrapper":"CalendarEvent_gfeWrapper__abtNL"};